import { APP_COPYRIGHT } from '@/lib/constants';

/**
 * Client footer component
 *
 * Displays copyright information and links at the bottom of the page.
 */
export function ClientFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-gray-900 md:px-6">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-500 dark:text-gray-400">
        <p className="text-center sm:text-left">{APP_COPYRIGHT}</p>
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
          <a
            href="/privacy"
            className="hover:text-gray-900 dark:hover:text-gray-100 text-xs sm:text-sm"
          >
            Privacy
          </a>
          <a
            href="https://snapes.com.au/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-900 dark:hover:text-gray-100 text-xs sm:text-sm"
          >
            Terms
          </a>
          <a
            href="/support"
            className="hover:text-gray-900 dark:hover:text-gray-100 text-xs sm:text-sm"
          >
            Support
          </a>
        </div>
      </div>
    </footer>
  );
}
